<template>
    <v-app-bar
      app
      color="primary"
      dark
      dense
    >



      <div class="d-flex align-center">
        <a href="/" >
        <img
              alt="Xsite"
              class="image-fit"
              src="../../../assets/images/logoXpectra.png"
              width="210px"
              height="50px"
              style="padding-top:7px"
            />
        </a>
      </div>

      <v-spacer></v-spacer>

      <span><h2 style="text-overflow: ellipsis; overflow: hidden; white-space: nowrap;">Cobertura Sigfox</h2></span>
      
      <v-spacer></v-spacer>


      <v-btn
        href="/About"
        text
        fab
      >
        <v-icon>mdi-help-box</v-icon>
      </v-btn>
      

      <v-btn
        href="/logout"
        text
        fab
      >
        <v-icon>mdi-exit-to-app</v-icon>
      </v-btn>
    </v-app-bar>
</template>

<style scoped src="@/assets/styles/NavigationBar.css"></style>

<script>

export default {
  name: 'NavBar'
}

</script>